export default __webpack_public_path__ + "static/media/trending-at-cutis-03.ff8e67c0.jpg";